export const products = [
  {
    id: 1,
    name: "Blanc Imperial Marble",
    category: "Marble",
    image: "https://readdy.ai/api/search-image?query=Elegant%20white%20marble%20slab%20with%20delicate%20grey%20veins%2C%20polished%20surface%2C%20luxury%20natural%20stone%2C%20professional%20product%20photography%20on%20neutral%20beige%20background%2C%20soft%20studio%20lighting%2C%20high-end%20architectural%20material%2C%20close-up%20texture%20detail%2C%20clean%20and%20minimal%20composition&width=600&height=450&seq=2&orientation=landscape",
    origin: "Coastal Quarry",
    application: "Kitchen countertops, flooring, hotel lobbies, bathrooms",
    description: "Renowned for its pure white background with subtle grey veining, Blanc Imperial is the crown jewel of our marble collection. Perfect for luxury interiors requiring timeless elegance.",
    featured: true,
  },
  {
    id: 2,
    name: "Gris Perle Marble",
    category: "Marble",
    image: "https://readdy.ai/api/search-image?query=Luxury%20grey%20marble%20slab%20with%20white%20and%20dark%20grey%20veins%2C%20polished%20stone%20surface%2C%20professional%20product%20photography%2C%20neutral%20warm%20background%2C%20soft%20studio%20lighting%2C%20high-end%20architectural%20material%2C%20elegant%20texture%20detail%2C%20minimal%20composition&width=600&height=450&seq=3&orientation=landscape",
    origin: "Coastal Quarry",
    application: "Commercial spaces, wall cladding, reception desks, flooring",
    description: "A sophisticated grey marble with flowing white veins, offering a modern alternative to traditional white marble. Ideal for contemporary architectural projects.",
    featured: false,
  },
  {
    id: 3,
    name: "Vert Emeraude Marble",
    category: "Marble",
    image: "https://readdy.ai/api/search-image?query=Luxury%20green%20marble%20slab%20with%20white%20and%20gold%20veins%2C%20polished%20natural%20stone%20surface%2C%20professional%20product%20photography%2C%20neutral%20warm%20background%2C%20soft%20studio%20lighting%2C%20high-end%20architectural%20material%2C%20elegant%20texture%20detail%2C%20minimal%20composition&width=600&height=450&seq=4&orientation=landscape",
    origin: "Eastern Quarry",
    application: "Feature walls, decorative elements, accent countertops, art pieces",
    description: "Rare and distinctive green marble with unique veining patterns. A statement stone that adds character and exclusivity to any design project.",
    featured: false,
  },
  {
    id: 4,
    name: "Premium Granite",
    category: "Granite",
    image: "https://readdy.ai/api/search-image?query=Dark%20granite%20slab%20with%20white%20and%20grey%20speckles%2C%20polished%20natural%20stone%20surface%2C%20professional%20product%20photography%2C%20neutral%20warm%20background%2C%20soft%20studio%20lighting%2C%20high-end%20architectural%20material%2C%20elegant%20texture%20detail%2C%20minimal%20composition&width=600&height=450&seq=5&orientation=landscape",
    origin: "Central Region",
    application: "Exterior cladding, kitchen countertops, high-traffic flooring",
    description: "Premium granite known for exceptional durability and resistance. The perfect choice for high-traffic commercial and residential applications.",
    featured: false,
  },
  {
    id: 5,
    name: "Premium Quartzite",
    category: "Quartzite",
    image: "https://readdy.ai/api/search-image?query=Luxury%20quartzite%20slab%20with%20white%20and%20beige%20crystalline%20texture%2C%20polished%20natural%20stone%20surface%2C%20professional%20product%20photography%2C%20neutral%20warm%20background%2C%20soft%20studio%20lighting%2C%20high-end%20architectural%20material%2C%20elegant%20texture%20detail%2C%20minimal%20composition&width=600&height=450&seq=6&orientation=landscape",
    origin: "Highland Region",
    application: "Kitchen countertops, bar tops, luxury bathrooms, feature walls",
    description: "Ultra-durable quartzite combining the beauty of marble with the strength of granite. Resistant to heat, scratches, and etching.",
    featured: false,
  },
  {
    id: 6,
    name: "Premium Travertine",
    category: "Travertine",
    image: "https://readdy.ai/api/search-image?query=Warm%20beige%20travertine%20slab%20with%20natural%20holes%20and%20cream%20texture%2C%20honed%20natural%20stone%20surface%2C%20professional%20product%20photography%2C%20neutral%20warm%20background%2C%20soft%20studio%20lighting%2C%20high-end%20architectural%20material%2C%20elegant%20texture%20detail%2C%20minimal%20composition&width=600&height=450&seq=7&orientation=landscape",
    origin: "Desert Region",
    application: "Outdoor pavers, pool surrounds, bathroom walls, rustic flooring",
    description: "Classic travertine with warm beige tones and natural pitting. Brings Mediterranean warmth and organic texture to both interior and exterior spaces.",
    featured: false,
  },
];

export const services = [
  {
    id: 1,
    title: "Import & Export Logistics",
    description: "Complete container shipping solutions from our quarry partners directly to European ports. We handle all customs documentation, freight forwarding, and port logistics.",
    icon: "ri-ship-line",
  },
  {
    id: 2,
    title: "Container Shipping",
    description: "Full container load (FCL) and less-than-container load (LCL) options. Regular shipments from our source regions to France, Spain, Italy, and across Europe.",
    icon: "ri-truck-line",
  },
  {
    id: 3,
    title: "Wholesale Supply",
    description: "Bulk orders for distributors, stone fabricators, and construction companies. Competitive B2B pricing with volume discounts and flexible terms.",
    icon: "ri-building-line",
  },
  {
    id: 4,
    title: "Custom Orders",
    description: "Tailored slab dimensions, specific thicknesses, and finishes for architects and builders. Project consultation and stone selection assistance included.",
    icon: "ri-tools-line",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Pierre Dubois",
    role: "Architect, Paris",
    text: "The quality of Blanc Imperial marble exceeded our expectations. Perfect for our luxury hotel project in Nice. Delivery was on time and the slabs were impeccably packaged.",
  },
  {
    id: 2,
    name: "Marie Lefevre",
    role: "Interior Designer, Lyon",
    text: "Working with Lithos has been a game-changer for our high-end residential projects. The stone selection is outstanding and the pricing is very competitive compared to Italian alternatives.",
  },
  {
    id: 3,
    name: "Ahmed Benali",
    role: "Construction Manager, Marseille",
    text: "Reliable supplier for our multi-unit developments. The container shipping process is smooth and the granite durability is exactly what we need for commercial flooring.",
  },
];